/**
 * Builds `path?query` with every value percent-encoded.
 *
 * Use this instead of concatenating user text into a URL. A raw '+' in an email address
 * (`name+tag@example.com`) is decoded to a space by `URLSearchParams`, which is what the pages read
 * through (`useSearchParams().get()`), and the page then hands Cognito a username it rejects.
 * `URLSearchParams` writes '+' as %2B, and '&', '#', '%' as their escapes, so `params.get(name)` on
 * the same class returns what went in. (A reader built on `decodeURIComponent` would keep a raw '+',
 * so encoding is not needed for it, but it is harmless there.)
 *
 * Params whose value is undefined, null or '' are left out, so callers can pass optional values
 * without their own `x ? '&x=' + x : ''` branches.
 */
export default function pathWithQuery(path, params = {}) {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
  ).toString();
  return query ? `${path}?${query}` : path;
}
